import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {AngularFireUploadTask} from '@angular/fire/compat/storage';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {DateAdapter, ErrorStateMatcher, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {finalize, Observable} from 'rxjs';
import {SitePublicService} from 'src/app/services/site-public.service';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';
import {FileManagerService} from 'src/app/shared/file-manager/file-manager.service';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';
import {SpinnerService} from 'src/app/shared/waiting/spinner.service';
import {CongressBeforePdfDialogComponent} from '../congress-before-pdf-dialog/congress-before-pdf-dialog.component';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-congress-before-dialog',
  templateUrl: './congress-before-dialog.component.html',
  styleUrls: [ './congress-before-dialog.component.scss' ]
})

export class CongressBeforeDialogComponent implements OnInit, OnDestroy {

  public matcher = new FormErrorStateMatcher(); // 
  public entityForm: FormGroup;
  public isEdit: boolean = false;

  // Variáveis para upload
  selectedFile: File | null = null;
  selectedFileName: any | null = null;
  storedImage: any | null = null;

  public pdfs$!: Observable<any[]>;

  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = [ 'name', 'file', 'preview', 'edit', 'delete' ];

  uploadTask: AngularFireUploadTask | undefined;
  uploadProgress: Observable<number | undefined> | undefined;
  downloadURL: string | null = null;
  isUploading = false;
  uploadError: string | null = null;

  constructor (
    public matDialogRef: MatDialogRef<CongressBeforeDialogComponent>,
    private fb: FormBuilder,
    private _adapter: DateAdapter<any>,
    private _snackBar: SnackBarIconService,
    private _dialog: MatDialog,
    private _sitePublicService: SitePublicService,
    private _fileManagerService: FileManagerService,
    private _spinnerService: SpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // console.log("dialog data: " + JSON.stringify(this.data));
    this.entityForm = this.createForm(this.data)
    this.isEdit = this.data.id !== '0';
  }

  ngOnInit () {
    this._adapter.setLocale('pt');
    if(this.isEdit){
      this.loadCongressPDFs(this.data.id);
    }
  }

  ngOnDestroy () { }

  createForm (data: any) {
    let form: FormGroup = this.fb.group({
      id: new FormControl(data.id),
      edition: new FormControl(data.edition, [ Validators.required ]),
      name: new FormControl(data.name, [ Validators.required ]),
      year: new FormControl(data.year, [ Validators.required ]),
      date: new FormControl(data.date, [ Validators.required ]),
      location: new FormControl(data.location, [ Validators.required ]),
      file: new FormControl(data.file),
      src: new FormControl(data.src),
      linkCertificate: new FormControl(data.linkCertificate),
    });

    this.selectedFileName = data.file;
    this.storedImage = data.src;

    return form
  }

  onFileSelected (event: any): void {
    const file: File = event.target.files[ 0 ];
    if (file) {
      this.selectedFile = file;
      this.entityForm.controls.file.setValue(file.name);
      this.previewImage(this.selectedFile)
    }
  }

  previewImage (selectedFile: any) {

    var reader = new FileReader();
    reader.readAsDataURL(selectedFile);
    reader.onload = (_event) => {
      this.storedImage = reader.result;
    }
  }

  deletePDF (element: any) {
    let dialogRef = this._dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.name + "<br><br>Excluir esta imagem?"}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._sitePublicService.deleteFileInStorage(element.src)

        this._sitePublicService.deleteBulletinPDF(this.data.id, element.id)
          .then(() => {
            this._snackBar.openSnackBar("Sucesso!", '', 'success')
          })
          .catch((err) => {
            this._snackBar.openSnackBar("Erro!", '', 'error')
          })
      }
    })
  }

  loadCongressPDFs(congress_id: string){
    this.pdfs$ = this._sitePublicService.loadCongressBeforePDFs(congress_id);
    this.pdfs$.subscribe(pdfs => {
    //  console.log("pages updated:" + JSON.stringify(pdfs));
      this.dataSource = new MatTableDataSource(pdfs);
    });
  }

  openPDFDialog (entity: any) {

    let data: any = {};
    if (entity) {
      data = {'id': entity.id, 'name': entity.name, 'src': entity.src, 'file': entity.file};
    } else {
      data = {'id': '0', 'name': '', 'src': '', 'file': ''};
    }

    // console.log("openPhotoDialog: " + JSON.stringify(data))

    let dialogRef = this._dialog.open(CongressBeforePdfDialogComponent, {
      width: '600px',
      height: '370px',
      panelClass: 'custom-dialog-container',
      data: data
    });

    dialogRef.afterClosed()
      .subscribe(async (response) => {
        if (!response) {
          return;
        }

        const actionType: string = response[ 0 ];
        const form: any = response[ 1 ];
        const selectedFile: any = response[ 2 ];
        const formData = form.getRawValue();
        const congress_id = this.data.id;

        /*
        console.log("actionType: " + actionType)
        console.log("congress_id: " + congress_id)
        console.log("selectedFile: " + selectedFile.name)
        console.log("insert: " + JSON.stringify(formData))
        */

        if (actionType == 'insert') {
          this._sitePublicService.insertCongressBeforePDF(congress_id, formData)
            .then((result) => {
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
              if (selectedFile) {
                this.startUpload(congress_id, result.id, selectedFile);
              } else {
                this._snackBar.openSnackBar("Sucesso!", '', 'success')
              }
            })
            .catch((err: any) => {
              this._snackBar.openSnackBar("Erro!", '', 'error')
            })
        } else if (actionType == 'update') {
          const pdf_id = formData.id;
          this._sitePublicService.updateCongressBeforePDF(congress_id, pdf_id, formData)
            .then(() => {
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
              if (selectedFile) {
                this._sitePublicService.deleteFileInStorage(data.src)
                this.startUpload(congress_id, pdf_id, selectedFile);
              } else {
                this._snackBar.openSnackBar("Sucesso!", '', 'success')
              }
            })
            .catch((err: any) => {
              console.log("erro: " + err.message)
              this._snackBar.openSnackBar("Erro!", '', 'error')
            })
        }

      })

  }

  startUpload (congress_id: string, pdf_id: string, selectedFile: any): void {
    const waiting = this._spinnerService.show();
    this._fileManagerService.storage_path = "site_pub/congresses-before/" + congress_id + "/" + pdf_id

    this.isUploading = true;
    this.uploadError = null;
    this.downloadURL = null;

    const {task, downloadURL$} = this._fileManagerService.uploadFile(selectedFile);
    this.uploadTask = task;

    // Acompanhar o progresso
    this.uploadProgress = this.uploadTask.percentageChanges();

    // Obter o URL de download e finalizar
    downloadURL$.pipe(
      finalize(() => {
        this.isUploading = false;
        this.uploadTask = undefined;
      })
    ).subscribe({
      next: (url) => {
        if (url) {
          this.downloadURL = url;
          this._sitePublicService.updateCongressBeforePDF(congress_id, pdf_id, {src: url})
            .then(() => {
              console.log("upload pdf success")
            })
            .catch((err) => {
              console.log("erro upload pdf")
            })
            .finally(() => {
              waiting.close();
            })

        }
      },
      error: (err) => {
        this.uploadError = 'Erro no upload: ' + (err.message || 'Desconhecido');
        console.error('Erro no upload:', err);
      }
    });
  }

  deleteCongrtessBeforePDF (congress_id: string, pdf_id: string) {
    console.log("delete")
  }

}

